(() => {
  const STORAGE_KEY = 'koozify-contact-attribution-v1';
  const STORAGE_TTL = 90 * 24 * 60 * 60 * 1000;
  const CLICK_IDENTIFIER_KEYS = ['gclid', 'wbraid', 'gbraid'];
  const UTM_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ];
  const ATTRIBUTION_KEYS = [...CLICK_IDENTIFIER_KEYS, ...UTM_KEYS];
  const FIELD_LIMITS = {
    gclid: 256,
    wbraid: 256,
    gbraid: 256,
    utm_source: 256,
    utm_medium: 256,
    utm_campaign: 256,
    utm_term: 256,
    utm_content: 500,
    landing_page: 1024,
    first_touch_time: 40,
  };

  const normalize = (value, limit) => {
    if (typeof value !== 'string') return '';
    return value.replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, limit);
  };

  const sanitizeRecord = (record) => {
    if (!record || typeof record !== 'object') return null;

    const sanitized = {};
    for (const key of Object.keys(FIELD_LIMITS)) {
      sanitized[key] = normalize(record[key], FIELD_LIMITS[key]);
    }

    const touchTime = Date.parse(sanitized.first_touch_time);
    if (!Number.isFinite(touchTime) || Date.now() - touchTime > STORAGE_TTL || touchTime - Date.now() > 60000) {
      return null;
    }

    if (!ATTRIBUTION_KEYS.some((key) => sanitized[key])) return null;
    return sanitized;
  };

  const removeStoredRecord = () => {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch {}
  };

  const readStoredRecord = () => {
    try {
      const record = sanitizeRecord(JSON.parse(window.localStorage.getItem(STORAGE_KEY)));
      if (!record) removeStoredRecord();
      return record;
    } catch {
      removeStoredRecord();
      return null;
    }
  };

  const writeStoredRecord = (record) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch {}
  };

  const getCurrentAttribution = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const attribution = {};

    for (const key of ATTRIBUTION_KEYS) {
      attribution[key] = normalize(searchParams.get(key), FIELD_LIMITS[key]);
    }

    if (!ATTRIBUTION_KEYS.some((key) => attribution[key])) return null;
    return attribution;
  };

  const mergeAttribution = (storedRecord, currentAttribution) => {
    if (!currentAttribution) return storedRecord;

    const mergedRecord = storedRecord || {};

    if (!storedRecord) {
      for (const key of ATTRIBUTION_KEYS) mergedRecord[key] = '';
      mergedRecord.landing_page = normalize(window.location.pathname, FIELD_LIMITS.landing_page);
      mergedRecord.first_touch_time = new Date().toISOString();
    }

    if (CLICK_IDENTIFIER_KEYS.some((key) => currentAttribution[key])) {
      for (const key of CLICK_IDENTIFIER_KEYS) {
        mergedRecord[key] = currentAttribution[key];
      }
    }

    for (const key of UTM_KEYS) {
      if (currentAttribution[key]) mergedRecord[key] = currentAttribution[key];
    }

    return mergedRecord;
  };

  const fillContactForms = (record) => {
    if (!record) return;

    document.querySelectorAll('form.contact-form__form [data-contact-attribution]').forEach((field) => {
      const key = field.dataset.contactAttribution;
      if (key && Object.prototype.hasOwnProperty.call(record, key)) field.value = record[key];
    });
  };

  const storedRecord = readStoredRecord();
  const currentAttribution = getCurrentAttribution();
  const activeRecord = mergeAttribution(storedRecord, currentAttribution);

  if (currentAttribution) writeStoredRecord(activeRecord);
  fillContactForms(activeRecord);
})();
